(function () {
  const SELECTOR =
    "#theme-section-template--18972536963225__featured_collection_bWU6n4 .swiper__custom-mask, \
     #theme-section-template--18972536963225__shop_the_feed_kXGc98 .swiper__custom-mask";

  const SPEED = 60; // px per second
  const PAUSE_ON_HOVER = true;

  function initScroller(container) {
    const wrapper = container.querySelector(".swiper-wrapper");
    if (!wrapper) return;

    // Duplicate slides once
    wrapper.innerHTML += wrapper.innerHTML;

    let offset = 0;
    let lastTime = null;
    let paused = false;
    let contentWidth = 0;

    function calculateWidth() {
      contentWidth = 0;
      const slides = wrapper.children;
      const half = slides.length / 2;

      for (let i = 0; i < half; i++) {
        contentWidth += slides[i].offsetWidth;
      }
    }

    function animate(time) {
      if (!lastTime) lastTime = time;
      const delta = (time - lastTime) / 1000;
      lastTime = time;

      if (!paused) {
        offset -= SPEED * delta;
        if (Math.abs(offset) >= contentWidth) {
          offset = 0;
        }
        wrapper.style.transform = `translate3d(${offset}px,0,0)`;
      }

      requestAnimationFrame(animate);
    }

    calculateWidth();
    requestAnimationFrame(animate);

    // Hover pause
    if (PAUSE_ON_HOVER) {
      container.addEventListener("mouseenter", () => (paused = true));
      container.addEventListener("mouseleave", () => (paused = false));
      container.addEventListener("touchstart", () => (paused = true), { passive: true });
      container.addEventListener("touchend", () => (paused = false));
    }

    // Recalc on resize
    window.addEventListener("resize", calculateWidth);
  }

  function initAll() {
    document.querySelectorAll(SELECTOR).forEach(initScroller);
  }

  document.readyState === "loading"
    ? document.addEventListener("DOMContentLoaded", initAll)
    : initAll();

  document.addEventListener("shopify:section:load", initAll);
})();
